import { jwtDecode } from "jwt-decode";
import { CommonEnums } from "../enums/common.enums";
import { LocalStorageHelpers } from "./helpers/localstorage.helpers";

export class AuthHelpers {
  static validateAccessToken = () => {
    const authTokens = LocalStorageHelpers.getAuthTokens();

    let accessToken = authTokens.access_token;

    if (!accessToken) accessToken = authTokens.temporary_access_token;

    if (accessToken) {
      try {
        const decodedToken = jwtDecode(accessToken);
        const expiresTime = (decodedToken?.exp || 0) * 1000;
        return expiresTime > new Date().getTime();
      } catch (e) {
        return false;
      }
    } else {
      return false;
    }
  };

  static logOut = () => {
    localStorage.clear();
    window?.location?.replace(`/`);
    return;
  };

  // static redirectToLogin = () => {
  //   localStorage.clear();
  //   window?.location?.replace(`/${RouteConstants.login}?step=login`);
  //   return;
  // };

  // static redirectToAuthentication = () => {
  //   localStorage.clear();
  //   window?.location?.replace(
  //     `/${RouteConstants.register}?step=user-verification`
  //   );
  //   return;
  // };

  static userValidation = () => {
    let userData: any =
      LocalStorageHelpers?.getAgentData() ||
      LocalStorageHelpers?.getAgencyData();

    let userValidate = false;

    if (userData?.role === CommonEnums?.userRole?.agency) {
      userValidate = true;
    } else {
      if (userData?.is_principal_agent) {
        userValidate = true;
      } else {
        userValidate = false;
      }
    }

    return userValidate;
  };

  static agentCheck = () => {
    let userData: any =
      LocalStorageHelpers?.getAgentData() ||
      LocalStorageHelpers?.getAgencyData();

    let userValidate = false;

    if (userData?.role === CommonEnums?.userRole?.agent) {
      userValidate = true;
    } else {
      userValidate = false;
    }

    return userValidate;
  };

  static agencyValidation = () => {
    let userData: any =
      LocalStorageHelpers?.getAgentData() ||
      LocalStorageHelpers?.getAgencyData();

    let userValidate = false;

    if (userData?.role === CommonEnums?.userRole?.agency) {
      userValidate = true;
    } else {
      userValidate = false;
    }

    return userValidate;
  };

  static getUserType = () => {
    const userData: any =
      LocalStorageHelpers?.getAgentData() || LocalStorageHelpers?.getAgencyData();
  
    return userData?.role || "";
  };
  
}
